var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page" },
    [
      _vm.league
        ? _c("EntityLandingHeader", {
            attrs: {
              backgroundImageUrl:
                _vm.$store.state.imagesCdn + "/" + _vm.league.image,
              entity: _vm.league
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.localPerformers.length > 0
        ? _c("section", { staticClass: "local-performers-section" }, [
            _c("div", { staticClass: "local-performer-filter-container" }, [
              _c("h2", { staticClass: "local-performer-filter-header" }, [
                _vm._v("Teams Near")
              ]),
              _vm._v(" "),
              _c(
                "section",
                { staticClass: "local-performer-filter" },
                [
                  _c("LocationFilter", {
                    attrs: {
                      "default-location": _vm.$config.defaultLocation
                        ? _vm.$config.defaultLocation
                        : _vm.userLocation,
                      location: _vm.location,
                      locationFilterCopy: ""
                    },
                    on: {
                      error: _vm.onLocationError,
                      select: _vm.onLocationSelect
                    }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c(
              "ul",
              { staticClass: "local-performers" },
              _vm._l(_vm.localPerformers, function(localPerformer) {
                return _c(
                  "router-link",
                  {
                    key: localPerformer.id,
                    staticClass: "local-performer-container",
                    attrs: { tag: "li", to: "/performers/" + localPerformer.id }
                  },
                  [
                    _c("div", { staticClass: "local-performer" }, [
                      ((localPerformer.images || {})[2] || {}).image
                        ? _c("div", {
                            staticClass: "local-performer__image",
                            style: {
                              backgroundImage:
                                "url(" + localPerformer.images[2].image + ")"
                            }
                          })
                        : _c("div", {
                            staticClass: "local-performer__image",
                            style: {
                              backgroundImage:
                                "url(" +
                                _vm.$store.state.imagesCdn +
                                "/" +
                                _vm.league.image +
                                ")"
                            }
                          }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "local-performer__image-text-container",
                          style: {
                            "background-color": localPerformer.primaryColor
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "local-performer__image-team-text" },
                            [_vm._v(_vm._s(localPerformer.name))]
                          )
                        ]
                      )
                    ])
                  ]
                )
              })
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("section", { staticClass: "team-navigation" }, [
        _c(
          "h2",
          {
            staticClass: "team-navigation__header",
            class: {
              "team-navigation__header--hide": _vm.localPerformers.length === 0
            }
          },
          [_vm._v("\n            Shop By Team\n        ")]
        ),
        _vm._v(" "),
        _c(
          "ul",
          { staticClass: "team-navigation__teams" },
          _vm._l(_vm.league.children, function(team) {
            return _c(
              "li",
              {
                key: team.slug,
                staticClass: "team-navigation__team",
                on: {
                  click: function($event) {
                    _vm.onMobilePerformerSelected(team.name, team.slug)
                  }
                }
              },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "team-icon-wrapper",
                    style: { background: team.primaryColor },
                    attrs: { tag: "button", to: team.slug },
                    nativeOn: {
                      click: function($event) {
                        _vm.onPerformerSelected(team.name)
                      }
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "team-icon-text",
                        style: { color: team.secondaryColor }
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(team.teamCode) +
                            "\n                    "
                        )
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "router-link",
                  {
                    staticClass: "team-nagivation__team-name",
                    attrs: { to: team.slug },
                    nativeOn: {
                      click: function($event) {
                        _vm.onPerformerSelected(team.name)
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(team.name) +
                        "\n                "
                    )
                  ]
                ),
                _vm._v(" "),
                _c("span", { staticClass: "icon-chevron-lg-right" })
              ],
              1
            )
          })
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }